import type { MachineStatus } from '@bridgewerk/shared';

const COLORS: Record<MachineStatus, string> = {
  running: 'var(--color-green)',
  idle: 'var(--color-yellow)',
  alarm: 'var(--color-red)',
  offline: '#1A3048',
};

export interface StatusDotProps {
  readonly status: MachineStatus;
  readonly size?: number;
  readonly glow?: boolean;
}

export function StatusDot({ status, size = 8, glow }: StatusDotProps): JSX.Element {
  const color = COLORS[status];
  const useGlow = glow ?? (status === 'running' || status === 'alarm');
  const isAlarm = status === 'alarm';
  return (
    <span
      aria-label={`status ${status}`}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        color,
        boxShadow: useGlow ? `0 0 ${size}px ${color}` : 'none',
        animation: isAlarm ? 'pulse-glow 1.6s ease-in-out infinite' : undefined,
        flexShrink: 0,
      }}
    />
  );
}
